import React from 'react';
import { SectionReveal } from './SectionReveal';
const rows = [['Hacer el Encuadre de cada sujeto obligado', '3 a 4 horas según tamaño de cartera'], ['Redactar Notificaciones diferenciadas por tipo de sujeto', '2 a 3 horas de redacción técnica'], ['Armar un cronograma propio con los plazos por sector', '1 hora más consultas y actualizaciones'], ['Responder las mismas consultas de WhatsApp', '15 a 20 minutos por consulta repetida'], ['Diseñar plantillas con el logo del estudio', '1 hora mínimo sin contar correcciones']];
export function CostOfInaction() {
  return <section className="w-full bg-alt" data-id="element-29" data-mp="3dp3lubpoftr9">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-20" data-id="element-30" data-mp="3iny5ffvgxmcf">
        <SectionReveal data-id="element-31" data-mp="3ipiyt261qz8p">
          <p className="text-center text-xs font-bold uppercase tracking-badge text-accent" data-id="element-32" data-mp="3nmrkhcqellep">
            El costo de hacerlo manualmente
          </p>
          <h2 className="mt-2 text-center text-2xl font-black leading-tight text-ink sm:text-3xl md:text-4xl" data-id="element-33" data-mp="3sm45drxpsien">
            ¿Cuánto te cuesta seguir resolviéndolo a mano?
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-34" data-mp="39g204kudi8tf">
          <p className="mt-6 text-center text-xs font-medium uppercase tracking-badge text-ink-soft md:hidden" data-id="element-35" data-mp="34i0im4clihk2">
            ← Scroll to see full table →
          </p>
          <div className="mt-3 overflow-x-auto rounded-2xl border border-alt bg-base shadow-sm" data-id="element-36" data-mp="30ii17ijzgolz">
            <table className="w-full min-w-[520px] border-collapse text-left" data-id="element-37" data-mp="10s15lls5jpv">
              <thead data-id="element-38" data-mp="3s960sq60dlxj">
                <tr className="bg-blue-dark text-white" data-id="element-39" data-mp="3s9xtnt8815k4">
                  <th className="px-5 py-3 text-sm font-bold" data-id="element-40" data-mp="3ng3100an1g8w">
                    Tarea sin el EstudioPack
                  </th>
                  <th className="px-5 py-3 text-sm font-bold" data-id="element-41" data-mp="3jfarr71rnbcm">
                    Tiempo no facturable
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-42" data-mp="f09w6ipo5t7o">
                {rows.map(([task, time], index) => <tr key={task} className={index % 2 === 0 ? 'bg-base' : 'bg-alt/50'} data-id="element-43" data-mp="298n604utcl4j" data-mpi={index}>
                    <td className="px-5 py-3 text-[15px] text-ink" data-id="element-44" data-mp="2e7hyjyil1o1u">{task}</td>
                    <td className="px-5 py-3 text-[15px] text-ink-soft" data-id="element-45" data-mp="1zibyy9fu1vtf">
                      {time}
                    </td>
                  </tr>)}
                <tr className="bg-accent/10" data-id="element-46" data-mp="1qiyp3fnsr586">
                  <td className="px-5 py-3 text-[15px] font-black text-ink" data-id="element-47" data-mp="1qh45q5s6bl67">
                    Total estimado
                  </td>
                  <td className="px-5 py-3 text-[15px] font-black text-accent" data-id="element-48" data-mp="1gkiyddsolxz7">
                    10 horas de trabajo administrativo no facturable
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-49" data-mp="3azbr9526kang">
          <div className="mt-8 rounded-r-xl border-l-4 border-accent bg-base p-5 shadow-sm" data-id="element-50" data-mp="3fxdbhtbceg0i">
            <p className="text-lg font-black leading-snug text-ink sm:text-xl" data-id="element-51" data-mp="14a9u0kum9raa">
              10 horas de trabajo administrativo no facturable vs. una inversión
              única de $27.990. El número habla solo.
            </p>
          </div>
        </SectionReveal>
      </div>
    </section>;
}